export enum DASHBOARD_WIDGET_TYPE {
  MAINTENANCE_DUE_MILES = 1,
  MAINTENANCE_DUE_HOURS = 2,
  MAINTENANCE_DUE_PERIOD = 3,
  ASSET_MAINTENANCE = 4, // Maintenance Overdue
  ASSET_STATUS = 5,
  // ASSET_AVAILABILITY = 6, //temporary disable
  SAFETY_EVENTS = 7,
  SAFETY_EVENTS_ASSET = 8,
  // SAFETY_EVENTS_DRIVER = 9, //temporary disable
  // FLEET_FUEL_SUMMARY = 10, //temporary disable
  // ASSET_FUEL_EFFICIENCY = 11, //temporary disable
  // DRIVER_FUEL_EFFICIENCY = 12, //temporary disable
  ASSET_IDLING_RATIO = 13,
  DRIVER_IDLING_RATIO = 14,
  // CUSTOM = 15,
  CUSTOM = 9999,
  FUEL_ENERGY_CONSUMPTION = 15,
  // VEHICLE_EFFICIENCY_COMPARISON = 16, //temporary disable
  // KEY_PERFORMANCE_INDICATORS = 17, //temporary disable
}

export const DASHBOARD_WIDGET_CATEGORIES = {
  safety: [
    DASHBOARD_WIDGET_TYPE.SAFETY_EVENTS,
    DASHBOARD_WIDGET_TYPE.SAFETY_EVENTS_ASSET, // Asset Events
    // DASHBOARD_WIDGET_TYPE.SAFETY_EVENTS_DRIVER, //temporary disable // Driver Performance
  ] as DASHBOARD_WIDGET_TYPE[],
  fuel: [
   // DASHBOARD_WIDGET_TYPE.FLEET_FUEL_SUMMARY, //temporary disable
    // DASHBOARD_WIDGET_TYPE.ASSET_FUEL_EFFICIENCY, //temporary disable
    DASHBOARD_WIDGET_TYPE.ASSET_IDLING_RATIO,
    DASHBOARD_WIDGET_TYPE.FUEL_ENERGY_CONSUMPTION,
    // DASHBOARD_WIDGET_TYPE.VEHICLE_EFFICIENCY_COMPARISON, //temporary disable
    // DASHBOARD_WIDGET_TYPE.KEY_PERFORMANCE_INDICATORS,
  ] as DASHBOARD_WIDGET_TYPE[],
  maintenance: [
    DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_HOURS,
    DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_MILES,
    DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_PERIOD,
    DASHBOARD_WIDGET_TYPE.ASSET_MAINTENANCE,
    DASHBOARD_WIDGET_TYPE.ASSET_STATUS,
    // DASHBOARD_WIDGET_TYPE.ASSET_AVAILABILITY, //temporary disable
  ] as DASHBOARD_WIDGET_TYPE[],
};

// values for custom section in add widgets
export const ADD_CUSTOM_WIDGETS = {
  USE: 3,
  CREATE: 4,
  LIST: 5,
};

export const DASHBOARD_WIDGET_TYPE_W_DETAILS_OPTION = [
  DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_HOURS,
  DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_MILES,
  DASHBOARD_WIDGET_TYPE.MAINTENANCE_DUE_PERIOD,

  DASHBOARD_WIDGET_TYPE.SAFETY_EVENTS_ASSET, // Asset Events
  // DASHBOARD_WIDGET_TYPE.SAFETY_EVENTS_DRIVER, //temporary disable // Driver Performance

  // DASHBOARD_WIDGET_TYPE.ASSET_FUEL_EFFICIENCY, //temporary disable
  DASHBOARD_WIDGET_TYPE.ASSET_IDLING_RATIO,
];

export enum DASHBOARD_WIDGET_GRAPH_TYPE {
  PIE_CHART = 1,
  DOUGHNUT_CHART = 2,
  VERTICAL_BAR_GRAPH = 3,
  HORIZONTAL_BAR_GRAPH = 4,
  STACKED_GRAPH = 5,
  LINE_GRAPH = 6,
}

export type DashboardWidget = {
  custom_widget_title?: string;
  custom_widget?: any;
  config: any;
  created_at: string;
  dashboard: number;
  id: number;
  name: DASHBOARD_WIDGET_TYPE | null;
  page_column: number;
  type: DASHBOARD_WIDGET_GRAPH_TYPE;
  updated_at: string;
  category?: string;
};

export type CustomWidgetBasic = {
  group_by: string;
  x_axis: string;
  y_axis: string;
  show_average: boolean;
};
export type CustomWidget = CustomWidgetBasic & {
  created_at: string;
  graph_type: number;
  id: number;
  custom_widget: number;
  is_pivot: boolean;
  report: number;
  title: string;
  updated_at: string;
  user: number;
  dashboard_type: DASHBOARD_WIDGET_TYPE.CUSTOM;
  category: string;
};

export type DashboardItem = {
  created_at: string;
  id: number;
  is_default: boolean;
  name: string;
  updated_at: string;
  user: number;
  widgets: DashboardWidget[];
};

export type CreateDashboardPayload = Partial<DashboardItem> & {
  widgets?: Partial<DashboardWidget>[];
};

export type UpdateDashboardPayload = CreateDashboardPayload & {
  id: number;
  widgets?: Partial<DashboardWidget>[];
};

export type TCustomWidgetPayload = {
  report: number;
  title: string;
  x_axis: string;
  y_axis: string;
  group_by: string;
  graph_type: number;
  show_average: boolean;
};

export type TEditCustomWidgetPayload = TCustomWidgetPayload & {
  widget_id: number;
};

export default {};
